import React from 'react';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import './Large-Image-Component.scss';

const LargeImageComponentPreview = (props) => {
  const { config } = props;

  return (
    <div className='large-image-component-preview'>
      {!config.isVideo && (
        <div className={`${config?.shadowOverlay ? 'shadowed-img' : ''}`}>
          <div
            className='d-flex align-items-center justify-content-center h-100 main-image-container'
            style={
              config?.imgURL
                ? {
                    backgroundImage: 'url(' + ASSET_URL + config?.imgURL + ')',
                    backgroundSize: 'cover',
                    height: '100px',
                  }
                : {
                    backgroundSize: 'cover',
                    height: '100px',
                  }
            }
          >
            <div className='slide-title'>{config?.imgURL ? '' : 'Large Image'}</div>
          </div>
        </div>
      )}
      {config.isVideo && (
        <div className={`${config?.shadowOverlay ? 'shadowed-img' : ''}`}>
          <video
            width={'100%'}
            height={'100%'}
            autoPlay
            loop={config?.loopPlayBack}
            preload='auto'
            src={config?.videoURL}
            muted
          />
        </div>
      )}
    </div>
  );
};

export default LargeImageComponentPreview;
